import Shortcut from '../utils/Shortcut';
import Tool, { simpleToolButton, type IToolActionInput } from './Tool';
import searchIcon from '../assets/icons/search.svg';
import { svgToIcon } from '../utils/svg';

class ToolSearch extends Tool {
  static toolName = 'Search whiteboard';
  static shortcut = new Shortcut('Cmd+F');

  static action({ controller }: IToolActionInput) {
    controller.actionShowSearchBar();
  }

  static enabled() {
    return true;
  }

  static buttonComponent() {
    return simpleToolButton(ToolSearch, svgToIcon(searchIcon));
  }
}

export default ToolSearch;
